import { openScreen } from '@shef/native-bridge';
import cn from 'classnames';
import { ClientEvents } from 'common/events/ClientEvents';
import { NavClickElementName } from 'common/events/ClientTypes';
import React from 'react';
import { Link } from 'react-router-dom';
import arrowSrc from 'src/assets/svg/arrow-forward-2.svg';
import { useNativeAppMessenger } from 'src/mobile-app/NativeAppMessengerContext';
import { useLocation } from 'src/shared/hooks/useLocation';
import { useTracker } from 'src/shared/hooks/useTracker';
import { locationInRoutes } from 'src/shared/utils/RouteUtilities';
import { useScreenContext } from 'web-common/src/shared/context/ScreenContext/hook';

interface MenuItemProps {
  name: NavClickElementName;
  icon: React.ReactNode;
  onClick?: () => void;
  text: React.ReactNode;
  href?: string;
  type: string;
  screen?: string;
}

export const MenuItem: React.FC<MenuItemProps> = ({ name, icon, onClick, text, href, type, screen }) => {
  const { isSmallScreen } = useScreenContext();
  const cypressName = `${name}-menu-item`;
  const tracker = useTracker();
  const nativeAppMessenger = useNativeAppMessenger();
  const location = useLocation();
  const isActive = Boolean(type === 'link' && href && locationInRoutes(location, [href]));

  const content = (
    <>
      <div className='-mt-1 mr-2 flex items-center justify-center'>{icon}</div>
      <span className='grow' id='link-text'>
        {text}
      </span>
      {isSmallScreen ? <img src={arrowSrc} style={{ height: 16, width: 8 }} alt='arrow' /> : null}
    </>
  );

  const handleClick = () => {
    onClick?.();
    tracker.track(ClientEvents.NAV_CLICK, { elementName: name });
  };
  return type === 'app' ? (
    <div
      className='mb-4 flex cursor-pointer items-center text-lg md:text-xl'
      onClick={() => {
        if (!nativeAppMessenger) {
          throw new Error(`App menu item ${name} rendered without nativeAppMessenger`);
        }

        nativeAppMessenger.sendRequest(openScreen, { screen }).then(handleClick).catch(console.error);
      }}
      data-cy={cypressName}>
      {content}
    </div>
  ) : (
    <Link
      className={cn('flex h-12 cursor-pointer items-center text-xl max-md:py-2', {
        'text-black hover:text-black focus:text-black': !isActive,
        'font-bold text-raspberry hover:text-raspberry-hover': isActive,
      })}
      data-cy={cypressName}
      onClick={handleClick}
      to={{ pathname: href }}
      target={type === 'externalLink' ? '_blank' : undefined}
      rel='noopener'>
      {content}
    </Link>
  );
};
